export default __webpack_public_path__ + "static/media/19_desktop.de5d171c.jpg";